<div class="d-flex flex-wrap py-1">
  <div class="d-flex flex-wrap align-item-center">
    <div class="ml-1">
      <input type="search" name="keyword" [ngModel]="criteria.Keyword" delay="1000" placeholder="جستجو"
        (debounce)="navigate('q',$event.target.value||undefined)">
    </div>
    <div class="ml-1">
      <select [ngModel]="criteria.Status" (ngModelChange)="navigate('status',$event)">
        <option [ngValue]="undefined">وضعیت</option>
        <option [ngValue]="OrganizationStatus.Unknown">همه</option>
        <option [ngValue]="OrganizationStatus.Active">فعال</option>
        <option [ngValue]="OrganizationStatus.Pending">در انتظار</option>
        <option [ngValue]="OrganizationStatus.Rejected">تایید نشده</option>
      </select>
    </div>
    <div class="ml-1">
      <input type="search" name="query" [ngModel]="criteria.Query" delay="1000" placeholder="حدس"
        (debounce)="navigate('query',$event.target.value||undefined)">
    </div>
  </div>
  <div class="d-flex align-items-center flex-fill">
    <app-pagination class="mx-auto" [total]="total" [limit]="limit"></app-pagination>
  </div>
  <div class="d-flex align-items-center">
    <button class="btn btn-sm btn-secondary mx-1" (click)="newOrganization()">ثبت شرکت</button>
  </div>
</div>
<div>
  <div *ngFor="let organization of list" class="kp-card mx-0">
    <div class="d-flex flex-wrap justify-content-between align-items-center ">
      <div class="d-flex align-items-center">
        <button class="btn btn-icon-circle ml-2" (click)="openEdit(organization)"><i
            class="fa fa-edit f-green fs-normal"></i></button>
        <div class="d-flex align-items-center">
          <div *ngIf="organization.Logo" class="ml-2" style="height:60px;width:80px;">
            <img [src]="organization.Logo?.startsWith('http') ? organization.Logo : imageUrl+organization.Logo"
              class="w-100 mw-100 h-100 mh-100 contain" />
          </div>
          <div>
            <h6 class="mb-0" (click)="organization._open=!organization._open">{{organization.Title}}</h6>
          </div>
          <div class="mx-2">
          </div>
        </div>
      </div>
    </div>
    <pre *ngIf="organization._open">{{organization|json}}</pre>
  </div>

</div>

<ngx-smart-modal #organizationModal identifier="organizationModal" customClass="full-width">
  <div class="p-2 cobtainer" *ngIf="selected" [style.min-width]="Utility.mobile? undefined : '800px'">
    <h2 *ngIf="!selected.Id">ثبت شرکت یا سازمان</h2>
    <div class="d-flex">
      <label class="flex-fill align-items-center m-1">
        <input [(ngModel)]="selected.Title" placeholder="عنوان" />
      </label>
      <label class="flex-fill align-items-center m-1">
        <input [(ngModel)]="selected.TitleEn" placeholder="عنوان انگلیسی" />
      </label>
    </div>
    <div class="rounded-xl border p-2">
      <input type="file" #file (change)="loadImage(file.files[0])" style="display:none;" accept=".jpg,.jpeg,.png">
      <ng-container *ngIf="!((image && preview) || currentImage)">
        <button class="btn" type="button" (click)="file.click()">انتخاب تصویر</button>
      </ng-container>
      <ng-container *ngIf="(image && preview) || currentImage">
        <i class="fa fa-times fs-xl f-red mx-3" (click)="removeImage(file)"></i>
        <img [src]="preview||currentImage" class="ml-3" style="max-height:80px">
      </ng-container>
    </div>
    <div class="flex-fill m-1">
      <h6>تگ‌ها</h6>
      <ng-select #selector [items]="tags" [(ngModel)]="selected.Tags" [selectOnTab]="true" [multiple]="true"
        placeholder="تگ‌ها" [addTag]="true">
      </ng-select>
      <!-- <textarea rows="5" [(ngModel)]="selected._tags"></textarea> -->
    </div>
    <div class="d-flex">
      <div class="flex-fill m-1">
        <h6>توضیحات</h6>
        <textarea rows="3" [(ngModel)]="selected.Description"></textarea>
      </div>
      <div class="flex-fill m-1">
        <h6>جایگزین‌ها</h6>
        <ng-select #selector [(ngModel)]="selected.Variations" [selectOnTab]="true" [multiple]="true"
          placeholder="جایگزین‌ها" [addTag]="true">
        </ng-select>
        <!-- <textarea rows="4" [(ngModel)]="selected._variations"></textarea> -->
      </div>
      <div>
        <button (click)="suggestVaraiations(selected)">پیشنهاد</button>
      </div>
    </div>

    <div class="p-1">
      <button class="btn mx-1" (click)="save(selected)">ذخیره</button>
      <button class="btn btn-red mx-1" *ngIf="selected.Id" (confirm)="remove(selected)">حذف</button>
    </div>
  </div>
</ngx-smart-modal>